export default __webpack_public_path__ + "nsfw-card-static-909079.jpg";